export default __webpack_public_path__ + "static/segoe-d4762843c5894790c2f976da4078c321.svg";